import styled from 'styled-components';

export const StyledMedicineOutdatedIconTooltipContent = styled.span`
   white-space: nowrap;
`;
StyledMedicineOutdatedIconTooltipContent.displayName = 'StyledMedicineOutdatedIconTooltipContent';
